import EditMessage from '../components/editMessage/EditMessage';

function MessageEdit() {
  return <EditMessage />;
}

export default MessageEdit;
